function canadaUploader(
  list,
  category,
  extention = "jpeg",
  callback = function (response) {},
  zip = true,
  categoryList = null,
  customText = ""
) {
  //global variable
  const serverSidePath =
    "https://canadaphotolab.com/wp-content/themes/printspace/shopify";
  const color = "#053a31";
  let counter = 0;
  let response = "";
  let maxSize = 1024 * 1024 * 5; // MB
  let partCounter = 0;
  let tempFile = 0;
  let imageSize = 0;
  let zipLimit = 5;
  let uniqId = "";

  //check list
  if (list.length === 0) {
    console.log("[Error] Vancouver Uploader : Image list is empty");
    return;
  }

  //check upload cover Exist
  if ($("#vancouverUploadCover").length === 0)
    $("body").append(
      '<div id="vancouverUploadCover" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,.9); z-index: 999999; display: none;"> <div style="position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); width: 80%; text-align: center; color: #053a31; text-shadow: rgba(0, 0, 0, 0.2) 0 0 5px;"> <div id="vancouverProgressCircle" style="width: 150px; height: 150px; border-radius: 150px; position: relative; margin: 0 auto 10px auto;"> <div id="vancouverProgressCover" style="background: #ffffff; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); width: 80%; height: 80%; border-radius: 150px;"> <div id="vancouverPercentUpload" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);"> <span id="vancouverPercentCount" style=" color: #053a31; font-weight: bold;display: block;font-size: 1.5em;">0%</span> <span id="vancouverSizeCount" style=" color: #053a31; font-weight: bold;display: block;font-size: 0.5em;">0 / 0 mb</span> </div> </div> </div> <span id="vancouverUploadCoverText" style="font-size: 2em; color: #053a31; font-weight: bold;">Uploading images ...</span> </div> </div>'
    );

  //show cover
  $("#vancouverUploadCover").show();
  if (customText !== "") {
    $("#vancouverUploadCoverText").html(customText);
  } else {
    $("#vancouverUploadCoverText").html("Preparing for upload...");
  }

  //XMLHttpRequest declare
  let xhr = new XMLHttpRequest();
  xhr.upload.addEventListener("progress", progress, false);
  xhr.addEventListener("load", load, false);
  xhr.addEventListener("error", error, false);
  xhr.timeout = 1800000;

  //upload first one in list
  upload();

  //in procces
  function progress(evt) {
    if (evt.lengthComputable) {
      let loaded = 0;
      if (partCounter > 0) loaded = maxSize * (partCounter - 1) + evt.loaded;
      else loaded = evt.loaded;

      let percent = Math.round((loaded * 100) / imageSize);

      if (percent > 100) percent = 100;

      $("#vancouverPercentCount").html(percent + "%");

      $("#vancouverSizeCount").html(
        Math.round((loaded / (1024 * 1024)) * 100) / 100 +
          " / " +
          Math.round((imageSize / (1024 * 1024)) * 100) / 100 +
          " MB"
      );

      let deg = (percent * 360) / 100;
      if (deg <= 180)
        $("#vancouverProgressCircle").css(
          "background",
          "linear-gradient(" +
            (deg - 90) +
            "deg, #eee 50%, transparent 50%),linear-gradient(-90deg, " +
            color +
            " 50%, #eee 50%)"
        );
      else
        $("#vancouverProgressCircle").css(
          "background",
          "linear-gradient(" +
            (deg - 270) +
            "deg, " +
            color +
            " 50%, transparent 50%),linear-gradient(-90deg, " +
            color +
            " 50%, #eee 50%)"
        );

      if (percent === 100 && counter === list.length - 1) {
        if (customText !== "") {
          $("#vancouverUploadCoverText").html(customText);
        } else {
          $("#vancouverUploadCoverText").html(
            "Upload Completed.\nProcessing..."
          );
        }
      } else if (percent === 100) {
        if (customText !== "") {
          $("#vancouverUploadCoverText").html(customText);
        } else {
          $("#vancouverUploadCoverText").html(
            "Processing Image " + (counter + 1) + " of " + list.length
          );
        }
      }
    }
  }

  //success upload
  function load(evt) {
    let res = evt.target.responseText;

    if (res.includes(".txt")) {
      tempFile = res;
      xhr.abort();
      upload(false, true);
    } else if (!res.includes("." + extention)) {
      xhr.abort();
      upload(true);
    } else {
      if (customText !== "") {
        $("#vancouverUploadCoverText").html(customText);
      } else {
        $("#vancouverUploadCoverText").html("Upload completed\nProcessing...");
      }

      let testImage = new Image();
      testImage.src = res;
      testImage.onload = function () {
        if (testImage.height === 0) {
          xhr.abort();
          upload(true);
        } else {
          if (counter < list.length - 1) {
            response += res;

            xhr.abort();
            if (uniqId === "") {
              // uniqId = res.replace("-" + (counter+1) + "." + extention ,"");
              // uniqId = uniqId.replace(serverSidePath + 'vancouverUpload/',"");
              // uniqId = uniqId.replace("\n",'');
              uniqId = res.replace("\n", "");
              let ss = uniqId.length;
              let es = extention.length;
              let ns = counter.toString().length;
              let end = ss - es - ns - 2 - 13;
              uniqId = uniqId.substr(end).substr(0, 13);
            }
            counter++;
            upload();
          } else {
            if (list.length >= zipLimit && zip) {
              response += res;

              if (customText !== "") {
                $("#vancouverUploadCoverText").html(customText);
              } else {
                $("#vancouverUploadCoverText").html(
                  "Upload completed\nProcessing..."
                );
              }

              zipping(response);
            } else {
              response += res;

              if (customText !== "") {
                $("#vancouverUploadCoverText").html(customText);
              } else {
                $("#vancouverUploadCoverText").html(
                  "Upload completed\nProcessing..."
                );
              }

              callback(response);
            }
          }
        }
      };
    }
  }

  //fail upload
  function error(evt) {
    $("#vancouverUploadCover").hide();
    alert(
      "Upload Failed : " +
        xhr.status +
        " : " +
        xhr.statusText +
        "\n" +
        evt.target.responseText
    );
  }

  //uploading
  function upload(retry = false, nextPart = false) {
    //set text
    if (retry) {
      if (customText !== "") {
        $("#vancouverUploadCoverText").html(customText);
      } else {
        $("#vancouverUploadCoverText").html(
          "Your connection is slow.\nRetry Uploading Image " +
            (counter + 1) +
            " of " +
            list.length
        );
      }
    } else {
      if (customText !== "") {
        $("#vancouverUploadCoverText").html(customText);
      } else {
        $("#vancouverUploadCoverText").html(
          "Uploading Image " + (counter + 1) + " of " + list.length
        );
      }
    }

    imageSize = list[counter].length;

    if (nextPart) partCounter++;
    else if (imageSize > maxSize && partCounter === 0) partCounter = 1;
    else partCounter = 0;

    if (partCounter === 0) {
      let fd = new FormData();
      fd.append("counter", counter + 1);
      fd.append("data", list[counter]);
      fd.append("extension", extention);
      if (categoryList !== null) fd.append("category", categoryList[counter]);
      else fd.append("category", category);
      fd.append("partCounter", partCounter);
      fd.append("uniqId", uniqId);
      xhr.open("POST", serverSidePath + "/upload.php");
      xhr.send(fd);
    } else {
      let start = (partCounter - 1) * maxSize;
      let end = partCounter * maxSize;
      if (end > imageSize) end = imageSize;
      let imagePart = list[counter].slice(start, end);

      let fd = new FormData();

      fd.append("counter", counter + 1);
      fd.append("data", imagePart);
      fd.append("extension", extention);
      if (categoryList !== null) fd.append("category", categoryList[counter]);
      else fd.append("category", category);
      fd.append("tmpFile", tempFile);
      fd.append("partCounter", partCounter);
      fd.append("uniqId", uniqId);

      if (Math.ceil(imageSize / maxSize) === partCounter)
        fd.append("partEnd", 1);
      else fd.append("partEnd", 0);

      xhr.open("POST", serverSidePath + "/upload.php");
      xhr.send(fd);
    }
  }

  //set zip file
  function zipping(response) {
    $.ajax({
      url: serverSidePath + "/zip.php",
      method: "POST",
      data: {
        fileList: response,
        category: category,
      },
      success: function (data) {
        callback(data);
      },
      error: function () {
        console.log("[Error] Vancouver Uploader : Zipping Error");
      },
    });
  }
}

//canvas home page first click
$(document).ready(function () {
  //the last update 
  $(function () {
    const $targets = $(
      "#sh-template--19335169212651__sh_tab_wise_image_2_KtdLCk .sh-twi-2-tab-item:eq(0) .sh-twi-2-tab-item-media p, " +
      "#Slide-template--19335169212651__multicolumn_DjRVXX-1 h4, " +
      "#Slide-template--19335169179883__multicolumn_WmCUwX-1 h4, " +
      ".sp-iswap-grid .sp-iswap-grid-item:eq(1) strong"
    );

    $targets.off("click.selectFileNS").on("click.selectFileNS", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if ($("#selectFile").length === 0) {
        $("body").append("<input type='file' id='selectFile' style='display:none;' multiple>");
      }

      if ($(this).closest(".sp-iswap-grid-item").length) {
        $("#selectFile")
          .attr("data-size", "8-8")
          .attr("data-price", "12.99")
          .trigger("click");
      } else {
        $("#selectFile")
          .removeAttr("data-size")
          .removeAttr("data-price")
          .trigger("click");
      }
      return false;
    });
  });


  $("body").on("change", "#selectFile", function (e) {
    var files = e.target.files;

    // ❌ PNG NOT ALLOWED
    for (var i = 0; i < files.length; i++) {
      if (files[i].type === "image/png") {
        alert("Only JPG or JPEG formats are allowed.");
        $("#selectFile").val("");
        return;
      }
    }

    var list = [];
    var listCounter = 0;

    getList();

    function getList() {
      if (listCounter > files.length - 1) {
        var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
        if (ext === "jpg") ext = "jpeg";
        canadaUploader(
          list,
          "CanvasPrint",
          ext,
          function (response) {
            var url = "https://shop.canadaphotolab.com/products/canvas-prints?imgSrc=" +
              response.replaceAll("\n", "|||");
            var selSize = $("#selectFile").attr("data-size");
            var selPrice = $("#selectFile").attr("data-price");
            if (selSize) { url += "&size=" + selSize; }
            if (selPrice) { url += "&price=" + selPrice; }
            location.replace(url);
          },
          null,
          null,
          "Please Wait Processing..."
        );
      }
      getImage(files[listCounter], function (pic) {
        list.push(pic);
        listCounter++;
        getList();
      });
    }

    function getImage(file, callback = function () {}) {
      var picReader = new FileReader();
      picReader.readAsDataURL(file);
      picReader.onerror = function () {
        alert("Can't read this file : " + file.name);
      };
      picReader.onload = function () {
        callback(picReader.result);
      };
    }
  });
});

//photoprint home page first click
$(document).ready(function () {
  $("#Slide-template--19335169179883__multicolumn_WmCUwX-2 h4 , #Slide-template--19335169212651__multicolumn_DjRVXX-2 h4 ,#sh-template--19335169212651__sh_tab_wise_image_2_KtdLCk .sh-twi-2-tab-item:eq(1) .sh-twi-2-tab-item-media p").on(
    "click",
    function () {
      if ($("#selectFile2").length == 0) {
        $("body").append(
          "<input type='file' id='selectFile2' style='display:none;' multiple>"
        );
      }

      $("body").find("#selectFile2").click();
    }
  );

  $("body").on("change", "#selectFile2", function (e) {
    var files = e.target.files;

    // ❌ PNG NOT ALLOWED
    for (var i = 0; i < files.length; i++) {
      if (files[i].type === "image/png") {
        alert("Only JPG or JPEG formats are allowed.");
        $("#selectFile2").val("");
        return;
      }
    }

    var list = [];
    var listCounter = 0;

    getList();

    function getList() {
      if (listCounter > files.length - 1) {
        var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
        if (ext === "jpg") ext = "jpeg";
        canadaUploader(
          list,
          "PhotoPrint",
          ext,
          function (response) {
            location.replace(
              "https://shop.canadaphotolab.com/products/photo-prints?imgSrc=" +
              response.replaceAll("\n", "|||")
            );
          },
          null,
          null,
          "Please Wait Processing..."
        );
      }
      getImage(files[listCounter], function (pic) {
        list.push(pic);
        listCounter++;
        getList();
      });
    }

    function getImage(file, callback = function () {}) {
      var picReader = new FileReader();
      picReader.readAsDataURL(file);
      picReader.onerror = function () {
        alert("Can't read this file : " + file.name);
      };
      picReader.onload = function () {
        callback(picReader.result);
      };
    }
  });
});

//metal print home page first click
$(document).ready(function () {
  $("#Slide-template--19335169179883__multicolumn_WmCUwX-4 h4 , #Slide-template--19335169212651__multicolumn_DjRVXX-4 h4,#sh-template--19335169212651__sh_tab_wise_image_2_KtdLCk .sh-twi-2-tab-item:eq(3) .sh-twi-2-tab-item-media p").on(
    "click",
    function () {
      if ($("#selectFile3").length == 0) {
        $("body").append(
          "<input type='file' id='selectFile3' style='display:none;' multiple>"
        );
      }

      $("body").find("#selectFile3").click();
    }
  );

  $("body").on("change", "#selectFile3", function (e) {
    var files = e.target.files;

    // ❌ PNG NOT ALLOWED
    for (var i = 0; i < files.length; i++) {
      if (files[i].type === "image/png") {
        alert("Only JPG or JPEG formats are allowed.");
        $("#selectFile3").val("");
        return;
      }
    }

    var list = [];
    var listCounter = 0;

    getList();

    function getList() {
      if (listCounter > files.length - 1) {
        var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
        if (ext === "jpg") ext = "jpeg";
        canadaUploader(
          list,
          "MetalPrint",
          ext,
          function (response) {
            location.replace(
              "https://shop.canadaphotolab.com/products/metal-prints?imgSrc=" +
              response.replaceAll("\n", "|||")
            );
          },
          null,
          null,
          "Please Wait Processing..."
        );
      }
      getImage(files[listCounter], function (pic) {
        list.push(pic);
        listCounter++;
        getList();
      });
    }

    function getImage(file, callback = function () {}) {
      var picReader = new FileReader();
      picReader.readAsDataURL(file);
      picReader.onerror = function () {
        alert("Can't read this file : " + file.name);
      };
      picReader.onload = function () {
        callback(picReader.result);
      };
    }
  });
});

//framedprint home page first click
$(document).ready(function () {
  $("body").on(
    "click",
    "#Slide-template--19335169212651__multicolumn_DjRVXX-3 h4, \ #Slide-template--19335169179883__multicolumn_WmCUwX-3 h4,\
    #sh-template--19335169212651__sh_tab_wise_image_2_KtdLCk .sh-twi-2-tab-item:eq(2) .sh-twi-2-tab-item-media p,\
     #Slider-template--19335169212651__multicolumn_gtpaGc > li, \
     .sp-iswap-grid .sp-iswap-grid-item:eq(0)",
    function () {
      if ($("#selectFile65").length == 0) {
        $("body").append(
          "<input type='file' id='selectFile65' style='display:none;' multiple>"
        );
      }

      var size = undefined;
      var id = $(this).attr("id");
      if (
        id &&
        id.startsWith("Slide-template--19335169212651__multicolumn_gtpaGc")
      ) {
        size = $(this).find("h3").html().replace('"', "").replace("x", "-");
      }

      var isPromoGrid = $(this).is(".sp-iswap-grid .sp-iswap-grid-item:eq(0)");
      if (!size && isPromoGrid) {
        size = "8-10"; // default vertical size for monthly deal
      }
      var promoPrice = isPromoGrid ? "14.99" : "";
      $("body").find("#selectFile65")
        .attr("data-size", size || "")
        .attr("data-price", promoPrice)
        .click();

    }
  );

  $("body").on("change", "#selectFile65", function (e) {
    var files = e.target.files;

    // ❌ PNG NOT ALLOWED
    for (var i = 0; i < files.length; i++) {
      if (files[i].type === "image/png") {
        alert("Only JPG or JPEG formats are allowed.");
        $("#selectFile65").val("");
        return;
      }
    }

    var list = [];
    var listCounter = 0;
    var selectedSize = $(this).attr("data-size");
    var promoPrice = $(this).attr("data-price");

    getList();

    function getList() {
      if (listCounter > files.length - 1) {
        var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
        if (ext === "jpg") ext = "jpeg";
        canadaUploader(
          list,
          "FramedPrint",
          ext,
          function (response) {
            var url = "https://shop.canadaphotolab.com/products/framed-prints?imgSrc=" + response.replaceAll("\n", "");
            var promoPrice = $("body").find("#selectFile65").attr("data-price");
            var finalSize = selectedSize || $("body").find("#selectFile65").attr("data-size");
            if (finalSize) {
              url += "&size=" + finalSize;
            }
            if (promoPrice) {
              url += "&price=" + promoPrice;
            }
            location.replace(url);
          },
          null,
          null,
          "Please Wait Processing..."
        );
        return; // خروج بعد از آپلود
      }

      getImage(files[listCounter], function (pic) {
        list.push(pic);
        listCounter++;
        getList();
      });
    }

    function getImage(file, callback = function () {}) {
      var picReader = new FileReader();
      picReader.readAsDataURL(file);
      picReader.onerror = function () {
        alert("Can't read this file : " + file.name);
      };
      picReader.onload = function () {
        callback(picReader.result);
      };
    }
  });
});


//photogift home page first click
$(document).ready(function(){
    var productId = 0;
    
    $("#Slide-template--20126087119083__multicolumn_8pTAQT-1 .rte,#Slide-template--20126087119083__multicolumn_8pTAQT-2 .rte,#Slide-template--20126087119083__multicolumn_8pTAQT-3 .rte,#Slide-template--20126087119083__multicolumn_8pTAQT-4 .rte").on("click",function(){
        if($("#selectFile45").length == 0)
        {
            $("body").append("<input type='file' id='selectFile45' style='display:none;' multiple>");
        }

        if($(this).parents("li").attr("id") === "Slide-template--20126087119083__multicolumn_8pTAQT-1")
        {
            productId = 100;
        }
        else if($(this).parents("li").attr("id") === "Slide-template--20126087119083__multicolumn_8pTAQT-2")
        {
            productId = 101;
        }
        else if($(this).parents("li").attr("id") === "Slide-template--20126087119083__multicolumn_8pTAQT-3")
        {
            productId = 103;
        }
        else if($(this).parents("li").attr("id") === "Slide-template--20126087119083__multicolumn_8pTAQT-4")
        {
            productId = 102;
        }
        $("body").find("#selectFile45").click();
    });

    $(".sp-iswap-grid .sp-iswap-grid-item:eq(2) strong,.sh-twi-2-tab-item:eq(4) .sh-twi-2-tab-item-media p , #Slide-template--19335169212651__multicolumn_DjRVXX-5 .rte h4").on("click",function(){
      if($("#selectFile45").length == 0)
      {
          $("body").append("<input type='file' id='selectFile45' style='display:none;' multiple>");
      }

      productId = 100;
      $("body").find("#selectFile45").click();
    });

    $("body").on("change","#selectFile45",function(e){
        var files = e.target.files;

        // ❌ PNG NOT ALLOWED
        for (var i = 0; i < files.length; i++) {
          if (files[i].type === "image/png") {
            alert("Only JPG or JPEG formats are allowed.");
            $("#selectFile45").val("");
            return;
          }
        }

        var list = [];
        var listCounter = 0;

        getList();

        function getList()
        {
            if(listCounter > files.length-1)
            {
                var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
                if (ext === "jpg") ext = "jpeg";
                canadaUploader(
                  list,
                  "PhotoGifts",
                  ext,
                  function(response){
                      location.replace("https://shop.canadaphotolab.com/products/photo-gifts/?imgSrc=" + response.replaceAll("\n","|||") + "&productId=" + productId)
                  },
                  null,
                  null,
                  "Please Wait Processing..."
              )
            }
            getImage(files[listCounter],function(pic){
                list.push(pic);
                listCounter++;
                getList();
            })
        }

        function getImage(file, callback = function(){}){
            var picReader = new FileReader();
            picReader.readAsDataURL(file);
            picReader.onerror = function () {
                alert("Can't read this file : " + file.name);
            }
            picReader.onload = function () {
                callback(picReader.result);
            }
        }
    });
});


//photo collage home page first click
$(document).ready(function(){
    $("#Slide-template--19335169212651__multicolumn_DjRVXX-8 .rte h4").on("click",function(){
        if($("#pcEditorLeftUploadAreaFile2").length == 0)
        {
            $("body").append("<input type='file' id='pcEditorLeftUploadAreaFile2' style='display:none;' multiple>");
        }

        $("body").find("#pcEditorLeftUploadAreaFile2").click();
    });

    $("body").on("change","#pcEditorLeftUploadAreaFile2",function(e){
        var files = e.target.files;

        // ❌ PNG NOT ALLOWED
        for (var i = 0; i < files.length; i++) {
          if (files[i].type === "image/png") {
            alert("Only JPG or JPEG formats are allowed.");
            $("#pcEditorLeftUploadAreaFile2").val("");
            return;
          }
        }

        var list = [];
        var listCounter = 0;

        getList();

        function getList()
        {
            if(listCounter > files.length-1)
            {
                var ext = files[0] && files[0].type ? files[0].type.split("/")[1] || "jpeg" : "jpeg";
                if (ext === "jpg") ext = "jpeg";
                canadaUploader(
                  list,
                  "PhotoCollage",
                  ext,
                  function(response){
                      location.replace("https://shop.canadaphotolab.com/products/photo-collage/?imgSrc=" + response.replaceAll("\n","|||"))
                  },
                  null,
                  null,
                  "Please Wait Processing..."
              )
            }
            getImage(files[listCounter],function(pic){
                list.push(pic);
                listCounter++;
                getList();
            })
        }

        function getImage(file, callback = function(){}){
            var picReader = new FileReader();
            picReader.readAsDataURL(file);
            picReader.onerror = function () {
                alert("Can't read this file : " + file.name);
            }
            picReader.onload = function () {
                callback(picReader.result);
            }
        }
    });
});



function mobileWarn()
{
    if($(window).width() < 768)
    {
        $("body").append('<div class="mobileWarn" style="position:fixed;z-index:9999999999;text-align:center;left:0;right:0;top:0;bottom:0;background:rgba(255,255,255,1);display:flex;align-items:center;justify-content:center"><div class="mobileWarnCon" style="width:300px"><img src="https://canadaphotolab.com/wp-content/uploads/elementor/thumbs/Canada-Photo-Lab-logo-px3kaem6hehv8t50beywrg59e0nl4yo3pauealm8v4.png" style="width:80%"><p style="font-size:1.2em">Unfortunately, this software is not optimized for mobile phones.</p><a href="https://shop.canadaphotolab.com/" style="padding:10px 20px;color:#fff;background:#053a31;font-size:1.2em;font-weight:700;text-decoration:none;border-radius:5px">Go To Homepage</a></div></div>');
        $(".mobileWarn").css("display","flex");
    }
}




document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // بخش 1: فقط در صفحه اصلی
  // =========================
  if (window.location.pathname === "/") {
    const links = document.querySelectorAll('.multicolumn-card .rte a');

    links.forEach(link => {
      if (
        link.textContent.trim().toLowerCase() === "read more" &&
        link.getAttribute("href") === "/products/photo-gifts"
      ) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          // انتقال به صفحه محصول + سکشن مشخص
          window.location.href =
            "/products/photo-gifts#shopify-section-template--20126087119083__multicolumn_8pTAQT";
        });
      }
    });
  }

  // =========================
  // بخش 2: در صفحه محصول (smooth scroll)
  // =========================
  if (window.location.pathname.startsWith("/products/photo-gifts")) {
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);

      if (target) {
        // مقدار قابل تنظیم: مدت زمان اسکرول (میلی‌ثانیه)
        const scrollDuration = 1200; // مثلا 1200ms = 1.2s

        // موقعیت نهایی المان
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const run = ease(timeElapsed, startPosition, distance, scrollDuration);

          window.scrollTo(0, run);

          if (timeElapsed < scrollDuration) requestAnimationFrame(animation);
        }

        // تابع ease (انیمیشن نرم)
        function ease(t, b, c, d) {
          t /= d / 2;
          if (t < 1) return (c / 2) * t * t + b;
          t--;
          return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
      }
    }
  }
});





